import React from "react";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Button,
  Table,
  Spinner,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import axios from "axios";
import { FaSearch } from "react-icons/fa";

import { getUrl } from "../../helpers/url";

import { useSelector, useDispatch } from "react-redux";

import DeleteModal from "../modals/DeleteModal";

import { setShowErrorModal } from "../../store/slice/modalSlice";
import { setShowSuccessModal } from "../../store/slice/modalSlice";

import SearchResultsNotFound from "../SearchResultsNotFound";
import MappingWindowHeader from "./MappingWindowHeader";
import EditMapping from "./EditMapping";
import MappedRows from "./MappedRows";
import SideBar from "./Sidebar";

import {
  fetchMappings,
  filterDefaultMappings,
  fetchPdProperties,
  sortPdFields,
  searchFilter,
  storeSelectedCountry,
  updateIsDirty,
  validatePdFields,
  checkRequiredFields,
} from "../../store/slice/mappingSlice";
const companyNumberField = [
  { name: "denmark", field: "CVR Number" },
  { name: "uk", field: "Company Number" },
  { name: "switzerland", field: "Unique Identification Number(UID)" },
  { name: "norway", field: "Organisation Number" },
  { name: "australia", field: "Australian Business Number(ABN)" },
  { name: "finland", field: "Business ID (Y-tunnus)" },
  // ... add more countries and their codes if needed
];

const findFieldByCountryName = (extractedCountry) => {
  for (const entry of companyNumberField) {
    if (entry.name === extractedCountry) {
      return entry.field;
    }
  }
  return "Company Number";
};
function Configurator() {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [saveBtnLoading, setSaveBtnLoading] = useState(false);

  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  const mapping = useSelector((state) => state.mapping.mappings.mappings);
  const loading = useSelector((state) => state.mapping.mappings.loading);
  const selectedCountry = useSelector((state) => state.mapping.selectedCountry);
  const defaultMappings = useSelector((state) => state.mapping.defaultMappings);
  const searchResults = useSelector((state) => state.mapping.searchResults);
  const searchInput = useSelector((state) => state.mapping.searchInput);
  const { isBtnDisabled } = useSelector((state) => state.mapping);
  const deletePipedriveFields = useSelector(
    (state) => state.mapping.deletePipedriveFields
  );
  // const addMapping = useSelector((state) => state.mapping.addMapping);
  const storedKey = useSelector((state) => state.mapping.storedKey);
  const enableEditing = useSelector((state) => state.mapping.enableEditing);
  const countries = useSelector((state) => state.mapping.countries);

  const pdProperties = useSelector(
    (state) => state.mapping.pipedrive.pdProperties
  );

  const getFilteredArray = (mappings) => {
    let filteredArray = [];
    Object.entries(mappings).forEach((mapping) => {
      if (
        deletePipedriveFields &&
        deletePipedriveFields.includes(mapping[1].key)
      ) {
        filteredArray.push({
          keyword: "pipedrive custom property deleted",
          key: mapping[0],
        });
      }
      if (mapping[1].key === "") {
        filteredArray.push({
          keyword: "",
          key: mapping[0],
        });
      }
      filteredArray.push({
        keyword: mapping[1].name,
        key: mapping[0],
      });
    });
    return filteredArray;
  };

  const onSortPdFields = () => {
    let filteredArray = getFilteredArray(
      searchInput.length > 1
        ? searchResults[selectedCountry]
        : defaultMappings[selectedCountry]
    );
    dispatch(sortPdFields(filteredArray));
  };

  const selectDefaultProperty = (value) => {
    if (deletePipedriveFields.includes(value.key)) {
      return {
        name: `custom property is deleted`,
        key: `-doesn'texists-`,
        type: undefined,
      };
    } else {
      return value;
    }
  };

  const disablePipedriveValue = (value) => {
    return Object.entries(defaultMappings[selectedCountry]).find((mapping) => {
      return mapping[1].key === value;
    });
  };

  const onSearchItems = (searchValue) => {
    const filteredArray = getFilteredArray(defaultMappings[selectedCountry]);

    const filter = filteredArray.filter(({ keyword, key }) => {
      return (
        keyword.toLowerCase().includes(searchValue.toLowerCase()) ||
        key.toLowerCase().includes(searchValue.toLowerCase())
      );
    });

    let filteredData = {};
    Object.keys(defaultMappings).forEach((country) => {
      filteredData[`${country}`] = {};
    });
    for (const item of filter) {
      filteredData[selectedCountry][item.key] =
        defaultMappings[selectedCountry][item.key];
    }
    dispatch(searchFilter({ searchValue, filteredData }));
  };

  const onChangeSelectedCountry = (value) => {
    dispatch(storeSelectedCountry(value));
  };

  const hideDeleteModal = () => setShowDeleteModal(false);

  useEffect(() => {
    const companyId = searchParams.get("companyId");
    if (companyId) {
      dispatch(fetchMappings(companyId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const companyId = searchParams.get("companyId");
    const userId = searchParams.get("userId");
    if (companyId && userId) {
      dispatch(fetchPdProperties({ companyId, userId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (mapping && Object.keys(mapping).length > 0 && selectedCountry) {
      dispatch(filterDefaultMappings());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapping]);

  useEffect(() => {
    if (
      defaultMappings &&
      Object.keys(defaultMappings).length > 0 &&
      Object.keys(pdProperties).length > 0
    ) {
      dispatch(validatePdFields());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultMappings, pdProperties, selectedCountry]);

  useEffect(() => {
    if (
      defaultMappings &&
      Object.keys(defaultMappings).length > 0 &&
      selectedCountry
    ) {
      dispatch(checkRequiredFields());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultMappings, selectedCountry]);

  return (
    <div>
      <DeleteModal show={showDeleteModal} hideDeleteModal={hideDeleteModal} />
      {loading ? (
        <div className="d-flex flex-column justify-content-center align-items-center loading-container">
          <div className="d-flex flex-row justify-content-center align-items-center">
            <Spinner animation="border" variant="success" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      ) : (
        <>
          {" "}
          <div className="search-button-container">
            <Form.Select
              className="selected-country form-control my-auto"
              value={selectedCountry}
              onChange={(e) => onChangeSelectedCountry(e.target.value)}
            >
              {countries.map((country, index) => (
                <option key={index} value={country}>
                  {country === "uk"
                    ? "UK"
                    : country[0].toUpperCase() + country.slice(1)}
                </option>
              ))}
            </Form.Select>
            <div className="search-sidebar-container">
              <div className="mapping-search-bar me-3">
                <span className="my-auto">
                  <FaSearch size={15} className="ms-3 search-icon" />
                </span>
                <input
                  type="search"
                  placeholder="Search"
                  onChange={(e) => onSearchItems(e.target.value)}
                  className="form-control mapping-search"
                  value={searchInput}
                />
              </div>
              <SideBar />
            </div>
          </div>
          {searchResults[selectedCountry] &&
          Object.keys(searchResults[selectedCountry]).length === 0 &&
          searchInput.length > 1 ? (
            <SearchResultsNotFound />
          ) : (
            <Table responsive className="table" bordered>
              <thead className="mapping-table-header">
                <MappingWindowHeader onSortPdFields={onSortPdFields} />
              </thead>
              <tbody className="table-body">
                {defaultMappings[selectedCountry] &&
                  Object.entries(
                    searchInput.length > 1
                      ? searchResults[selectedCountry]
                      : defaultMappings[selectedCountry]
                  ).map((el) => (
                    <tr
                      key={el[0]}
                      className={
                        enableEditing && storedKey === el[0]
                          ? "add-mapping-container"
                          : "mapped-row"
                      }
                    >
                      {enableEditing && storedKey === el[0] ? (
                        <EditMapping
                          mappedItem={el}
                          selectDefaultProperty={selectDefaultProperty}
                          disablePipedriveValue={disablePipedriveValue}
                        />
                      ) : (
                        <MappedRows
                          mappedItem={el}
                          selectDefaultProperty={selectDefaultProperty}
                          setShowDeleteModal={setShowDeleteModal}
                        />
                      )}
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
          <div className="d-flex justify-content-end">
            {Object.keys(searchResults).length === 0 &&
            searchInput.length > 1 ? (
              ""
            ) : (
              <>
                {deletePipedriveFields.length > 0 || isBtnDisabled ? (
                  <OverlayTrigger
                    placement="left"
                    overlay={
                      <Tooltip className="tool-tip">
                        {deletePipedriveFields.length > 0
                          ? "Please remap the fields for which custom property has been deleted"
                          : `Please map the Company Address and ${findFieldByCountryName(
                              selectedCountry
                            )} fields to save the mappings`}
                      </Tooltip>
                    }
                  >
                    <Button className="save-mapping-button disable-save-mapping-btn my-auto mt-2 ">
                      Save mappings
                    </Button>
                  </OverlayTrigger>
                ) : (
                  <Button
                    onClick={() =>
                      onSaveMappings({
                        setSaveBtnLoading,
                        defaultMappings,
                        searchParams,
                        dispatch,
                      })
                    }
                    disabled={enableEditing}
                    className="save-mapping-button mt-2"
                  >
                    {saveBtnLoading ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <span>Save mappings</span>
                    )}
                  </Button>
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default Configurator;

export const onSaveMappings = async ({
  setSaveBtnLoading,
  defaultMappings,
  searchParams,
  dispatch,
}) => {
  try {
    setSaveBtnLoading(true);
    let fields = {};
    Object.keys(defaultMappings).forEach((country) => {
      fields[`${country}`] = {};
    });
    Object.keys(defaultMappings).forEach((country) => {
      for (const key in defaultMappings[country]) {
        if (defaultMappings[country][key].key !== "undefined") {
          fields[country][key] = defaultMappings[country][key];
        }
      }
    });
    const companyId = searchParams.get("companyId");
    await axios.post(getUrl("REACT_APP_SAVE_MAPPINGS"), {
      companyId,
      mappings: { ...fields },
    });
    dispatch(updateIsDirty(false));
    setSaveBtnLoading(false);
    dispatch(
      setShowSuccessModal({
        message:
          "cmsContent.notifications.mappingWindow.successContent.saveMapping.message",
      })
    );
  } catch (error) {
    console.log(error);
    let errorMessage;
    if (error.response && error.response.data.message)
      errorMessage = error.response.data.message;
    else errorMessage = error.message;
    dispatch(setShowErrorModal({ message: errorMessage }));
    setSaveBtnLoading(false);
  }
};
